export enum pathENUM {
  home = '/',
  programs = '/programs',
  news = '/news',
  events = '/events',
  organizations = '/units',
  talents = '/talents',
  register = '/register',
  map = '/map',
  profile = '/profile',
  instructions = '/instructions',
  parentInstructions = '/instructions/parents',
  documents = '/documents',
}

export const routeTitleMap = {
  [pathENUM.programs]: 'Программы',
  [pathENUM.news]: 'Статьи',
  [pathENUM.events]: 'Мероприятия',
  [pathENUM.organizations]: 'Организации',
  [pathENUM.talents]: 'Талантливые дети и молодежь',
}
